'use client';

import { Check } from 'lucide-react';
import { clsx } from 'clsx';
import { TAG_COLOR_OPTIONS, type TagColorId } from './tag-colors';

interface TagColorSwatchesProps {
  /** Aktuell gewählte Palette-ID (null = noch keine persistiert). */
  value: string | null;
  onChange: (color: TagColorId) => void;
  className?: string;
}

/**
 * Reihe runder Farb-Swatches (7 kuratierte Label-Farben) — Muster der
 * Akzent-Auswahl aus dem Projekt-Aktions-Sheet. Wird im „Labels verwalten"-Sheet
 * sowohl beim Umfärben einer Zeile als auch beim Anlegen genutzt.
 */
export function TagColorSwatches({ value, onChange, className }: TagColorSwatchesProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Farbe wählen"
      className={clsx('flex flex-wrap items-center gap-2', className)}
    >
      {TAG_COLOR_OPTIONS.map((c) => {
        const active = value === c.id;
        return (
          <button
            key={c.id}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={c.label}
            onClick={() => onChange(c.id)}
            className={clsx(
              'w-7 h-7 rounded-full inline-flex items-center justify-center text-white shadow-sm transition-transform',
              active
                ? 'ring-2 ring-offset-2 ring-gray-400'
                : 'hover:scale-110 active:scale-95',
            )}
            style={{ backgroundColor: c.hex }}
          >
            {active && <Check size={14} strokeWidth={3.2} />}
          </button>
        );
      })}
    </div>
  );
}
